import React from 'react';

import { Form, Icon } from 'semantic-ui-react';
import { Hbbs_keysToLabels } from 'xAppLib/UIelems/HobbiesModal';

const HobbiesField = ({ edit, uf_this, values }) => {
	const handleOpenModal = () => {
		app.trigger(app.events.SHOW_POPUP, {
			txt: 'Select Your Hobbies',
			pn: 'hobbies',
			noCloseBtn: true,
			cst_modal: true,
			uf_this,
			hobbiesValues: values.hbbs ?? []
		})
	};

	const hobbies = <p className="text grey">{values?.hbbs?.length > 0 ? Hbbs_keysToLabels(values.hbbs).join(', ') : 'None provided'}</p>;

	return (
		<Form.Field>
			<label>Your Hobbies</label>
			{edit && (
				<div className="flex items-center gap-2 cursor-pointer" onClick={handleOpenModal}>
					<Icon size="small" name="edit" />
					{hobbies}
				</div>
			)}

			{!edit && hobbies}
		</Form.Field>
	);
};

export default HobbiesField;
